"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _Parcel = _interopRequireDefault(require("../parcel/Parcel"));

var _Action = _interopRequireDefault(require("../change/Action"));

var _ChangeRequest = _interopRequireDefault(require("../change/ChangeRequest"));

var _isPlainObject = _interopRequireDefault(require("unmutable/lib/util/isPlainObject"));

var _RUNTIME_TYPES;

var RUNTIME_TYPES = (_RUNTIME_TYPES = {}, (0, _defineProperty2.default)(_RUNTIME_TYPES, 'boolean', {
  name: "a boolean",
  check: function check(ii) {
    return typeof ii === "boolean";
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'dispatchable', {
  name: "an Action, an array of Actions, or a ChangeRequest",
  check: function check(ii) {
    return ii instanceof _Action.default || Array.isArray(ii) && ii.every(function (jj) {
      return jj instanceof _Action.default;
    }) || ii instanceof _ChangeRequest.default;
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'event', {
  name: "an event",
  check: function check(ii) {
    return ii && ii.currentTarget;
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'function', {
  name: "a function",
  check: function check(ii) {
    return typeof ii === "function";
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'keyIndex', {
  name: "a key or an index (string or number)",
  check: function check(ii) {
    return typeof ii === "string" || typeof ii === "number";
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'keyIndexPath', {
  name: "an array of keys or indexes (strings or numbers)",
  check: function check(ii) {
    return ii && Array.isArray(ii) && ii.every(function (jj) {
      return typeof jj === "string" || typeof jj === "number";
    });
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'number', {
  name: "a number",
  check: function check(ii) {
    return typeof ii === "number";
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'object', {
  name: "an object",
  check: function check(ii) {
    return (0, _typeof2.default)(ii) === "object";
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'parcel', {
  name: "a Parcel",
  check: function check(ii) {
    return ii instanceof _Parcel.default;
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'parcelData', {
  name: "an object containing parcel data {value: *, meta?: {}, key?: *}",
  check: function check(ii) {
    return (0, _isPlainObject.default)(ii) && ii.hasOwnProperty('value');
  }
}), (0, _defineProperty2.default)(_RUNTIME_TYPES, 'string', {
  name: "a string",
  check: function check(ii) {
    return typeof ii === "string";
  }
}), _RUNTIME_TYPES);

var _default = function _default(expecter, param, type) {
  return function (value) {
    var types = [].concat(type);
    var runtimeTypes = types.map(function (type) {
      var runtimeType = RUNTIME_TYPES[type];

      if (!runtimeType) {
        throw new Error("Unknown type check");
      }

      return runtimeType;
    });
    var valid = runtimeTypes.some(function (ii) {
      return ii.check(value);
    });

    if (!valid) {
      if (param.indexOf(' ') === -1) {
        param = "param \"".concat(param, "\"");
      }

      var typeNames = runtimeTypes.map(function (type) {
        return type.name;
      }).join(", "); // $FlowFixMe - I want to make value into a string regardless of flows opinions https://github.com/facebook/flow/issues/1460

      throw new Error("".concat(expecter, " expects ").concat(param, " to be ").concat(typeNames, ", but got ").concat(value + ""));
    }

    return value;
  };
};

exports.default = _default;